const getLDContext = function(userData) {
  return {
    kind: 'user',
    key: userData?.id,
    email: userData?.email,
    type: 'LENDER_USER',
    role: userData?.role?.name,
    lender: userData?.lender?.name,
    lender_name: userData?.lender?.name,
    lender_id: userData?.lender?.id,
    _meta: {
      privateAttributes: ['email'],
    },
  }
}

const defaultAnonymousContext = {
  kind: 'user',
  anonymous: true,
  key: 'unidentified_init_user',
  name: 'init_user',
  lender_name: 'init_lender',
  email: 'init_user@reggora.com',
  type: 'LENDER_USER',
  _meta: {
    privateAttributes: ['email'],
  },
}

/**
 * Longest sign-in waits on LaunchDarkly at any one step -- for the client to
 * exist, and then for the signed-in user's flags. Past it, the app renders
 * anyway rather than stall sign-in on a slow or unreachable LaunchDarkly.
 */
const LD_IDENTIFY_TIMEOUT_MS = 1500

/**
 * Switch LaunchDarkly to this user and wait for their flags -- bounded.
 *
 * The app renders as soon as auth initializes. Without waiting here, the first
 * render still sees the anonymous context's flags, so any page that decides
 * on a flag while mounting (a guard that redirects, a section that hides) acts
 * on the wrong value -- on a hard refresh, before identify has returned.
 *
 * Never rejects: a failed or slow identify must not fail sign-in. Returns what
 * happened so the caller can log it.
 *
 * @returns {Promise<'identified'|'timeout'|'failed'>}
 */
const identifyWithTimeout = async (ldClient, context, timeoutMs = LD_IDENTIFY_TIMEOUT_MS) => {
  let timer
  const timedOut = new Promise((resolve) => {
    timer = setTimeout(() => resolve('timeout'), timeoutMs)
  })
  try {
    return await Promise.race([ldClient.identify(context).then(() => 'identified'), timedOut])
  } catch (err) {
    return 'failed'
  } finally {
    clearTimeout(timer)
  }
}

export { defaultAnonymousContext, getLDContext, identifyWithTimeout, LD_IDENTIFY_TIMEOUT_MS }
